import { ProfileProvider } from '@/providers/profile/profile.provider';
import { FeatureCode } from '@/utils/disabled-features/disabled-features.interface';
import { DisabledFeaturesService } from '@/utils/disabled-features/disabled-features.service';
import { inject, Injectable } from '@angular/core';
import { type CanActivateChildFn, type CanActivateFn, Router } from '@angular/router';
import { of, type Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EnergySignatureFeatureService {
    private _router = inject(Router);
    private _disabledFeaturesService = inject(DisabledFeaturesService);
    private _profileProvider = inject(ProfileProvider);

    goToFeature() {
        this._router.navigate(['/', 'energy-signature']);
    }

    hasFeatureAccess$(): Observable<boolean> {
        if (!this._disabledFeaturesService.isFeatureEnabled(FeatureCode.ENERGY_SIGNATURE)) {
            return of(false);
        }
        return this._profileProvider.hasInternalModuleAccess$();
    }

    async hasFeatureAccess(): Promise<boolean> {
        if (!this._disabledFeaturesService.isFeatureEnabled(FeatureCode.ENERGY_SIGNATURE)) {
            return false;
        }
        return this._profileProvider.hasInternalModuleAccess();
    }
}

export const energySignatureGuard: CanActivateFn & CanActivateChildFn = async () => {
    const featureService = inject(EnergySignatureFeatureService);
    const hasFeatureAccess = await featureService.hasFeatureAccess();

    if (!hasFeatureAccess) {
        return false;
    }
    return true;
};
